import { render, staticRenderFns } from "./report-assignments-table.vue?vue&type=template&id=a52f047a"
import script from "./report-assignments-table.vue?vue&type=script&lang=js"
export * from "./report-assignments-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports